@for (toast of this.notifications$ | async; track toast) {
  @if (toast.type === NotificationType.Toast) {
    <ngb-toast
      [class]="toast.notificationStatus | toastCss"
      class="text-light" id="{{toast.timestamp}}"
      [autohide]="true" [delay]="toast.timeout || 5000"
      (hidden)="remove(toast)"
      >{{ toast.content | translate }}
    </ngb-toast>
  }
}
